import type {
	GenericError,
	CategoryId,
} from '@atlassian/jira-servicedesk-knowledge-services/src/types';
import messages from './messages';

export const BROWSE_KNOWLEDGE_FAILURE =
	'state.actions.browse-knowledge-failure.BROWSE_KNOWLEDGE_FAILURE' as const;

export type BrowseKnowledgeFailureOpts = {
	page: number;
	statusCode: number;
	id: CategoryId;
};

export type BrowseKnowledgeFailureAction = {
	type: typeof BROWSE_KNOWLEDGE_FAILURE;
	payload: {
		id: CategoryId;
		page: number;
	} & GenericError;
};

export const browseKnowledgeFailure = (
	opts: BrowseKnowledgeFailureOpts,
): BrowseKnowledgeFailureAction => ({
	type: BROWSE_KNOWLEDGE_FAILURE,
	payload: {
		id: opts.id,
		page: opts.page,
		error: {
			message: messages.genericMessage,
			header: messages.genericHeader,
		},
	},
});
